export default __webpack_public_path__ + "static/media/elevate-pyl-3.bec21c62.png";